const InstrumentType = {
    PRIVATE_NCD: 'PrivateNCD',
    PUBLIC_NCD: 'PublicNCD',
    TREASURY_BILLS: 'TreasuryBill',
    SOVEREIGN_GOLD_BONDS: 'SovereignGoldBond',
    SECURITISED_DEBT_INSTRUMENT: 'SecuritisedDebtInstrument'
};

Object.freeze(InstrumentType);

module.exports = InstrumentType;
